import { createContext } from 'react'
import { translations } from '../constants/translations'

const TranslationsContext = createContext(translations)

export const TranslationsProvider = TranslationsContext.Provider
export default TranslationsContext
